import { render } from "./11.CtaSection.vue?vue&type=template&id=22ab309a&scoped=true"
import script from "./11.CtaSection.vue?vue&type=script&lang=js"
export * from "./11.CtaSection.vue?vue&type=script&lang=js"

import "./11.CtaSection.vue?vue&type=style&index=0&id=22ab309a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ab309a"]])

export default __exports__